var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7161 6.79498C2.67729 6.75628 2.64651 6.7103 2.6255 6.65968C2.6045 6.60906 2.59369 6.55479 2.59369 6.49998C2.59369 6.44518 2.6045 6.39091 2.6255 6.34029C2.64651 6.28967 2.67729 6.24369 2.7161 6.20498L6.53776 2.38415C6.77225 2.14977 6.90403 1.83183 6.90411 1.50028C6.90419 1.16873 6.77256 0.850729 6.53817 0.616234C6.30379 0.381738 5.98585 0.249956 5.6543 0.249878C5.32276 0.2498 5.00476 0.381432 4.77026 0.615817L0.948601 4.43748C0.402576 4.98501 0.0959473 5.72672 0.0959473 6.49998C0.0959473 7.27325 0.402576 8.01495 0.948601 8.56248L4.77026 12.3842C5.00476 12.6185 5.32276 12.7502 5.6543 12.7501C5.98585 12.75 6.30379 12.6182 6.53817 12.3837C6.77256 12.1492 6.90419 11.8312 6.90411 11.4997C6.90403 11.1681 6.77225 10.8502 6.53776 10.6158L2.7161 6.79498Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.742b377f2b5ac6bbd0e384fbf7bcb2ed.svg";
export { ForwardRef as ReactComponent };